import { BikDetailProps, GetBikProps } from 'app/dataTypes/account/bankDetails/BankDetailsTypes'

import type { Request } from '../../index'


type ResultAPI = {
  bank_title: string
  corr_account: string
}

export const convertResult = ({
  bank_title: bankTitle,
  corr_account: corrAccount,
}: ResultAPI): BikDetailProps => {
  return {
    bankTitle,
    corrAccount,
  }
}

type ApiParams = {
  bik: string
}

export const convertParams = ({ bik }: GetBikProps): [ApiParams, null] => {
  return [{ bik }, null]
}

export const GET_BIK_DETAILS: Request<GetBikProps, BikDetailProps, void> = [
  'service/bank_details_by_bik',
  'get',
  ['data', 'data'],
]
